import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'

/**
 * Action types.
 */

export const REQUEST_TEST_SOURCE_SETTINGS = 'REQUEST_TEST_SOURCE_SETTINGS'
export const REQUEST_TEST_SOURCE_SETTINGS_ERROR = 'REQUEST_TEST_SOURCE_SETTINGS_ERROR'
export const RECEIVED_TEST_SOURCE_SETTINGS = 'RECEIVED_TEST_SOURCE_SETTINGS'
export const CLEAR_TEST_SOURCE_SETTINGS = 'CLEAR_TEST_SOURCE_SETTINGS'

export const clearTestSourceSettings = createAction(CLEAR_TEST_SOURCE_SETTINGS)

/**
 * Tests the given settings with a source.
 * @param  {String} slug     Source slug
 * @param  {Object} settings Settings to test
 * @return {Object}
 */
export const testSourceSettings = (slug, settings, workspaceId) => ({
  types: {
    request: REQUEST_TEST_SOURCE_SETTINGS,
    failure: REQUEST_TEST_SOURCE_SETTINGS_ERROR,
    receive: RECEIVED_TEST_SOURCE_SETTINGS
  },
  payload: { slug },
  callAPI () {
    return fetch(`/api/metadata/source/${slug}/settings`, {
      method: 'POST',
      body: JSON.stringify({ settings, workspaceId })
    }).then(res => {
      if (!res.ok) {
        throw new Error(`Unable to validate the ${slug} settings`)
      }
      return res.json()
    })
  }
})



// WEBPACK FOOTER //
// ./actions/source-settings-validation.js